// extracted by mini-css-extract-plugin
module.exports = {"ListWrapper":"PostsList-module--ListWrapper--1FQNG","ListItem":"PostsList-module--ListItem--3NyMF","Link":"PostsList-module--Link--2tAfA"};